import { actionTypes, actionValues } from '../actions/constants';

export default function headerReducer(state = { initialTrackingFired: false }, action) {

    switch (action.type) {
        case actionTypes.SET_DRAWER_ANIMATION:
            const { animation } = action;
            const { SLIDE_IN, NONE } = actionValues.drawerAnimations;

            if (state.animation === NONE && animation === SLIDE_IN) {
                return state;
            }

            return {
                ...state,
                animation: action.animation
            };

        case actionTypes.SET_UPDATE_USER_STATE:
            return {
                ...state,
                updateUserState: action.updateUserState,
                initialTrackingFired: false
            };
        case actionTypes.INITIAL_TRACKING_FIRED:
            return {
                ...state,
                initialTrackingFired: true
            };
        case actionTypes.SET_USER_TYPE_TRADE:
            return {
                ...state,
                isUserTypeTrade: action.isUserTypeTrade
            };
        case actionTypes.SET_USER_TYPE_VIP:
            return {
                ...state,
                isUserTypeVip: action.isUserTypeVip
            };
        case actionTypes.SET_BANNER_MESSAGES:
            return {
                ...state,
                bannerMessages: action.bannerMessages
            };
        case actionTypes.SET_DEVICE_TYPE:
            return {
                ...state,
                deviceType: action.deviceType
            };
        case actionTypes.TOGGLE_MOBILE_MENU:
            return {
                ...state,
                isMobileMenuOpen: action.isMobileMenuOpen
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/headerReducer.js